module.exports = __webpack_public_path__ + "static/media/kids_room.2a3c5a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kids_room.jpg
// module id = 1888
// module chunks = 0